import React from "react";
import "./Home.css";
import Product from "./Product";
import Footer from "./Footer";
import { InfoSection } from './components';
import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour, homeObjFive, homeObjSix, homeObjSeven, homeObjEight } from './components/Data';
import { Link } from "react-router-dom";
import { Button } from './globalStyles';
import { useStateValue } from "./StateProvider";
import Widgets from "./Widgets";

function Services() {

    const [{ basket, user }, dispatch] = useStateValue();


    return (
        <div className="home" >
          <div >
           
         
    
       
  
<InfoSection {...homeObjThree} />

    
<div className="products" >
       <Widgets />
       <h1 className="storetitle">Please Visit Our Store we offer many Products for your home appliance needs</h1>
       <a className="bookapp"  href="https://7citiesappliance0499.setmore.com/">Book Virtual Appointment</a>
      </div>
            
    
     
            <Footer />
          </div>
        </div>
      );
    }
export default Services
